import React        from "react";
import Presentation from "./presentation";

const ConfirmModal = ( {
	buttonComponent,
	performAction,
	dialogText
} ) => {
	const [ open, setOpen ] = React.useState ( false );

	const handleClickOpen = () => {
		setOpen ( true );
	};

	const handleClose = () => {
		setOpen ( false );
	};

	return (
		<Presentation
			buttonComponent = { buttonComponent }
			dialogText      = { dialogText }
			handleClickOpen = { handleClickOpen }
			handleClose     = { handleClose }
			open            = { open }
			performAction   = { performAction }
		/>
	);
};

export default ConfirmModal;
